// General params
export const INTEGRATION_PARAM = 'integration';
export const INTEGRATIONS_PARAM = 'integrations';
export const THREAD_ID_PARAM = 'threadId';
export const SHEET_TAB_PARAM = 'tab';

// Dashboard params
export const GROUP_PARAM = 'group';
export const AFTER_TS_PARAM = 'afterTs';
export const BEFORE_TS_PARAM = 'beforeTs';
export const LIVE_PARAM = 'live';
export const GRAPH_PARAM = 'graph';
export const PROPERTY_PARAM = 'property';

// Messages params
export const SEARCH_PARAM = 'search';

// Models params
export const SHEET_OPEN_PARAM = 'open';

// Automation params
export const VERSION_PARAM = 'version';
export const RUN_ID_PARAM = 'runId';
export const MODE_PARAM = 'mode';
export const NEW_FLOW_PARAM = 'new';

// Message Sheet params
export const MESSAGE_SHEET_PARAM = 'message_sheet';
export const MESSAGE_SHEET_FILTERS_PARAM = 'sheet_filters';
export const MESSAGE_SHEET_SELECTED_PARAM = 'selected_message';
export const MESSAGE_SHEET_TAB_PARAM = 'sheet_tab';

// Message Feed params
export const MESSAGE_FEED_FILTERS_PARAM = 'sheet_filters';

// Process params
export const PROCESS_FILTERS_PARAM = 'process_filters';
export const PROCESS_EDGE_METRIC_PARAM = 'process_edge_metric';
export const PROCESS_PATH_LENGTHS_PARAM = 'process_path_lengths';
export const ACTIVITIES_FILTERS_PARAM = 'activities_filters';
export const PROCESS_VARIANTS_PARAM = 'process_variants';
export const PROCESS_VARIANT_PERCENTAGE_PARAM = 'process_variant_percentage';
